module.exports = __webpack_public_path__ + "static/img/bg_water.da5f6012.jpg";